module.exports = __webpack_public_path__ + "img/empty-boards.887ad29b.svg";